import type {
  StockAlertsQueryParams,
  StockLedgerQueryParams,
  StockListQueryParams,
} from '../model/types';

/** Centralised query keys; everything sits under the `inventory` root so a tenant switch can drop it all. */
export const INVENTORY_ROOT_KEY = 'inventory';

export const inventoryKeys = {
  all: [INVENTORY_ROOT_KEY] as const,

  stock: [INVENTORY_ROOT_KEY, 'stock'] as const,
  stockList: (params: StockListQueryParams) =>
    [INVENTORY_ROOT_KEY, 'stock', 'list', params] as const,
  stockByProduct: (productId: string) =>
    [INVENTORY_ROOT_KEY, 'stock', 'product', productId] as const,

  ledger: [INVENTORY_ROOT_KEY, 'ledger'] as const,
  ledgerList: (params: StockLedgerQueryParams) =>
    [INVENTORY_ROOT_KEY, 'ledger', 'list', params] as const,

  alerts: [INVENTORY_ROOT_KEY, 'alerts'] as const,
  alertsList: (params: StockAlertsQueryParams) =>
    [INVENTORY_ROOT_KEY, 'alerts', 'list', params] as const,

  policy: (productId: string, locationId: string) =>
    [INVENTORY_ROOT_KEY, 'policy', productId, locationId] as const,

  locations: [INVENTORY_ROOT_KEY, 'locations'] as const,
} as const;
